module.exports = __webpack_public_path__ + "img/level-2.7ec27998.png";